import React from 'react';
import ReactDom from 'react-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormGroup, Radio } from 'react-bootstrap';

export default class RadioGroup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedValue: props.value
        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(evt) {
        const { target } = evt
        this.setState({ selectedValue: target.value }, () => {
            if (this.props.onChange) {
                this.props.onChange({ target }, this.state.selectedValue);
            }
        });
    }

    render() {
        const classNames = classnames('radio-group', this.props.className);

        return (
            <FormGroup className={classNames}>
                {this.props.options.map((option, idx) => {
                    return (
                        <Radio
                            key={`radio-group-input-${idx}`}
                            id={option.value}
                            value={option.value}
                            name={this.props.name}
                            onChange={this.handleChange}
                            checked={!!(option.value === this.state.selectedValue)}
                            data-option-key={option.key}
                            data-option-text={option.text}
                        >
                            <div>
                                {option.label}
                                {option.tooltip && this.props.renderTooltip(option, idx)}
                            </div>
                        </Radio>
                    );
                })}
            </FormGroup>
        );
    }
}

RadioGroup.propTypes = {
    /**
     * The name of the radio group.
     *
     * Also used as part of unique id in tooltip
     */
    name: PropTypes.string.isRequired,
    /**
     * Array of radio button options: { label: 'optionLabel', value: 'optionValue' }
     */
    options: PropTypes.arrayOf(PropTypes.object).isRequired,
    /**
     * Value of the selected radio button
     */
    value: PropTypes.string,
    /**
     * @function onChange Callback fired when a radio button is selected.
     *
     * @param {Object} event The event source of the callback. You can access the value by accessing event.target.value.
     * @param {String} value The value of the selected radio button.
     * @returns void
     *
     */
    onChange: PropTypes.func,
    /**
     * @function renderTooltip Func. that renders additional inf. about option.
     *
     * @returns Component
     */
    renderTooltip: PropTypes.func
};
